import React, { FC } from 'react'
import { Row, Form, Col } from 'antd'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

// reducers
import { RootState } from '../../reducers'

// atoms
import CodeEditorField from '../../atoms/CodeEditorField'
import SelectField from '../../atoms/SelectField'

// utils
import { ELEMENT_ATTRIBUTES, FORM } from '../../utils/enums'

// interfaces
import { IForm } from '../../types/interfaces'

// helpers
import { extract, validateVariablesInQuery } from '../../utils/helper'

export type ComponentProps = {
	onSubmit: any
	columns: any
}

type Props = InjectedFormProps<IForm, ComponentProps> &
	ComponentProps & {
		handleSubmit: Function
	}

// validate variables in sql query
export const validateVariables = (value: string, allValues: any, props: any) => {
	const { columns } = props
	const variables: string[] = extract('{', '}', value)
	// validate if query variables match columns in table
	const diff: string[] = validateVariablesInQuery(columns?.data || [], variables)
	if (variables.length > 0 && diff.length > 0) {
		const diffVariables: string = JSON.stringify(diff)
		return i18next.t('loc:Please check this variables {{diffVariables}} because did not match columns in table array!', { diffVariables })
	}
	return undefined
}

const CodeEditorForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit } = props
	const disable = useSelector((state: RootState) => state.formTemplate.disable)
	const validableComponents = useSelector((state: RootState) => state.formTemplate.validableComponents)

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit} className={'w-full'}>
			<Row justify={'center'} className={'w-full'}>
				<div className={'w-full'}>
					<span>{t('loc:SQL select')}</span>
					<Field
						component={CodeEditorField}
						placeholder={t('loc:Enter SQL query')}
						name={ELEMENT_ATTRIBUTES.SQL}
						language={'sql'}
						size={'medium'}
						className={'tp-textarea'}
						disabled={disable}
						validate={validateVariables}
					/>
				</div>
				<Col span={24}>
					{' '}
					<Field
						component={SelectField}
						label={t('loc:Linked fields')}
						options={validableComponents?.data}
						mode={'multiple'}
						name={ELEMENT_ATTRIBUTES.LINKED_FIELDS}
						placeholder={t('loc:Select field')}
						size={'medium'}
						disabled={disable}
						clearBtn={true}
					/>{' '}
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IForm, ComponentProps>({
	form: FORM.SQL_EDITOR_FORM,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true
})(CodeEditorForm)

export default form
